import {REQUEST} from 'src/express.tokens';
import {isPlatformBrowser, isPlatformServer} from '@angular/common';
import {Inject, inject, Injectable, PLATFORM_ID} from '@angular/core';
import {Capacitor} from "@capacitor/core";

@Injectable({
    providedIn: 'root',
})
export class PlatformService {
    isBrowser = isPlatformBrowser(this.platformId);
    isServer = isPlatformServer(this.platformId);

    private request: undefined | Record<string, any>;

    userAgent: string =  '';

    private isIos: boolean = false;

    isAndroid: boolean = false;

    isMobile: boolean = false;

    isNative: boolean = Capacitor.isNativePlatform();

    constructor(
        @Inject(PLATFORM_ID) private platformId: Object,
    ) {
        try {
            this.request = inject(REQUEST);
            this.userAgent = this.request.headers['user-agent'];
        } catch {}
        this.isIos = /iPad|iPhone|iPod/.test(this.userAgent);
        this.isAndroid = /android|Android/i.test(this.userAgent);
        this.isMobile =  this.isIos || this.isAndroid;
    }


    



}
